export const updateEducation = ({ BeURL, id, education, handleTopClear }) => {
    fetch(`${BeURL}/candidate-education/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ education}),
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                alert(data.message);
                setTimeout(()=>{
                    window.location.reload()
                },[500])
                handleTopClear()
            } else {
                alert(data.message );
            }
        })
        .catch((err) => {
            console.log("Error in create Education", err);
        });
}
